import React from 'react'
import { Slider, ICONS } from '../../components'
import { ESignatureQRCodeDisplay } from './ESignatureQRCodeDisplay'
export type ESignaturePaneProps={
    id:string
    guid:string
    code:string
    type:string
    url:string
    btnSize:"md" | "sm" | "lg"
}

export const ESignaturePane = ({ id, guid, code, type, url,btnSize="md" }:ESignaturePaneProps) => {

  return (
    <Slider
      title={ICONS.SIGNATURE}
      header={
        <>
          <span className="mr-3">{ICONS.SIGNATURE}</span>
          <span>Add Signature</span>
        </>
      }
      sliderWidth={"50vw"}
      overlayClassName="on-top"
      size={btnSize}
    >
      <ESignatureQRCodeDisplay
        url={url}
        type={type}
        id={id}
        guid={guid}
        code={code}
        btnSize={"md"}
      />
    </Slider>
  )
}
